import React, { useState, useEffect } from 'react'
import moment from 'moment'
import { downloadcicdReport } from '../AdminActionCreator.component'
import Loader from '../../../presentationals/Loader/Loader.component'
import { APIS } from '../../../../utils/api-factory'
import { useSelector, useDispatch } from 'react-redux';
import { FILTER_ACTION } from '../../../../reducers/CommonFilters.reducer';
export default function CICDReport() {
    const dispatch = useDispatch();
    const { fromDate, toDate, nbfcId } = useSelector(state => state.FilterReduce.commonFilters);
    const [loader, setLoader] = useState(false)
    const [nbfcData, setnbfcData] = useState([])
    const [payload, setPayload] = useState({
        startDate: fromDate,
        endDate: toDate,
        nbfc: nbfcId
    })

    useEffect(() => {
        setPayload({
            startDate: fromDate,
            endDate: toDate,
            nbfc: nbfcId
        })

    }, [fromDate, toDate, nbfcId]);

    useEffect(() => {
        getNbfcList()
    }, [])

    const getNbfcList = () => {
        fetch(APIS.GET_LIST_OF_NBFC)
            .then(res => res.json())
            .then(res => {
                setnbfcData(res)
                setPayload({
                    startDate: fromDate,
                    endDate: toDate,
                    nbfc: res?.[0]?.nbfcId
                })
                dispatch({ type: FILTER_ACTION, payload: { nbfcId: res?.[0]?.nbfcId } });
            })
    }

    const downloadReport = () => {
        setLoader(true)
        const start = moment(payload?.startDate).format("DD-MM-YYYY")
        const end = moment(payload?.endDate).format("DD-MM-YYYY")
        downloadcicdReport(start, end, payload?.nbfc, callback => {
            setLoader(false)
        })
    }

    const handlechange = (e, type) => {
        const keyMap = {
            startDate: "fromDate",
            endDate: "toDate",
            nbfc: "nbfcId"
        };

        const key = keyMap[type];

        if (key) {
            dispatch({
                type: FILTER_ACTION,
                payload: { [key]: e.target.value }
            });
        }
        setPayload((prev) => ({
            ...prev,
            [type]: e.target.value
        }))
    }
    return (
        <>
            <div className="container-fluid">
                {
                    loader ? <Loader /> : ''
                }

                <h3 className='text-center blue-text'>CIC REPORT</h3>

                <div className="row" style={{ marginTop: '20px' }}>
                    <div className="col-sm-2 col-xs-12">
                        <label htmlFor="">Start Date</label>
                        <input type="date" value={payload?.startDate} className='form-control' onChange={(e) => handlechange(e, "startDate")} />
                    </div>
                    <div className="col-sm-2 col-xs-12">
                        <label htmlFor="">End Date</label>
                        <input type="date" value={payload?.endDate} className='form-control' onChange={(e) => handlechange(e, "endDate")} />
                    </div>
                    <div className="col-sm-2 col-xs-12">
                        <label htmlFor="">NBFC</label>
                        <select value={payload?.nbfc} className='form-control' onChange={(e) => handlechange(e, "nbfc")} >
                            {
                                nbfcData && nbfcData?.length > 0 ? nbfcData?.map((Val, id) => {
                                    return (
                                        <option value={Val?.nbfcId}>{Val?.name}</option>
                                    )
                                })
                                    : ""}
                        </select>
                    </div>
                    <div className="col-sm-2 col-xs-12">
                        <button className='btn btn-primary' style={{ padding: '10px', marginTop: '22px' }} onClick={() => downloadReport()}><i class="fa fa-download" aria-hidden="true"></i>&nbsp; Download</button>
                    </div>
                </div>
            </div>
        </>
    )
}
